import { List, Record } from 'immutable';
import invariant from 'invariant';
import { incaAccessor } from '@cancercentrum/inca';
import xor from 'lodash/xor';
import { createDataRow, createViewModel, createViewModelRow } from '../utils/data';
import SyncHook from '../SyncHook';
const staticHooks = {
    createRow: new SyncHook()
};
const SubTableModelRecord = Record({
    items: List(),
    $rcc: null
});
export class SubTableModel extends SubTableModelRecord {
    static hooks = staticHooks;
    constructor(values){
        values ? super(values) : super();
        invariant(values?.$rcc, '$rcc must be initialized.');
    }
    getRows() {
        const activeItems = this.items.filter((x)=>!x._destroy);
        if (activeItems.count() === this.items.count()) {
            return this.items;
        }
        return activeItems;
    }
    createRow() {
        let newRow;
        // Ex scopat formulär på startsida
        if (!incaAccessor()?.form?.createDataRow) {
            newRow = createViewModel(createDataRow(this.$rcc.tableName, this.$rcc.globalMetadata), this.$rcc.globalMetadata, this.$rcc.tableName);
        } else {
            const globalMetadataTables = Object.keys(incaAccessor().form.metadata);
            const thisMetadataTables = Object.keys(this.$rcc.globalMetadata);
            // Om createDataRow finns, verifiera att det är rätt formulär. Ex kan man ha en scopad komponent för ett annat register
            // och då blir det inte rätt att använda huvudformulärets metod.
            // Anta att det är samma formulär om det är exakt samma tabeller i metadatat.
            if (xor(globalMetadataTables, thisMetadataTables).length === 0) {
                newRow = createViewModelRow(this.$rcc.tableName);
            } else {
                newRow = createViewModel(createDataRow(this.$rcc.tableName, this.$rcc.globalMetadata), this.$rcc.globalMetadata, this.$rcc.tableName);
            }
        }
        return staticHooks.createRow.execReduce(newRow);
    }
    addRow(row) {
        const rowTableName = row.$rcc.tableName;
        const tableName = this.$rcc.tableName;
        if (rowTableName !== tableName) {
            throw new Error(`Cannot add the row because it belongs to another table. Expected a row for ${tableName} but got ${rowTableName}.`);
        }
        return this.update('items', (x)=>{
            return x.push(row);
        });
    }
    removeRow(rowId) {
        const rows = this.items;
        const rowIndex = rows.findIndex((x)=>x?.getId() === rowId);
        const row = rows.get(rowIndex);
        if (row?.id || row?.$extra?.registerRecordId) {
            return this.updateIn([
                'items',
                rowIndex
            ], (r)=>r.set('_destroy', true));
        }
        return this.removeIn([
            'items',
            rowIndex
        ]);
    }
    updateRow(rowId, updater) {
        const rowIndex = this.items.findIndex((x)=>x?.getId() === rowId);
        if (rowIndex === -1) {
            throw new Error(`${this.$rcc.tableName} does not have a row with id ${rowId}.`);
        }
        return this.updateIn([
            'items',
            rowIndex
        ], updater);
    }
    getErrors(options) {
        return this.getRows().reduce((reduction, row)=>{
            const rowErrors = row.getErrors(options);
            reduction.push(...rowErrors);
            return reduction;
        }, []);
    }
    toIncaJS() {
        return this.items.reduce((reduction, item)=>{
            reduction.push(item.toIncaJS());
            return reduction;
        }, []);
    }
}
